import React from 'react';
import './App.css';
import FlightMap from './components/FlightMap';
import SmallScreenWarning from './components/SmallScreenWarning';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <div className="App">
        <SmallScreenWarning />
        <FlightMap />
      </div>
    </ErrorBoundary>
  );
}

export default App;
